import { render, staticRenderFns } from "./QueEsLaHuella.vue?vue&type=template&id=c7feee2a"
import script from "./QueEsLaHuella.vue?vue&type=script&lang=js"
export * from "./QueEsLaHuella.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports